function BookkeepingOperatorCtrl(toaster, $stateParams, BookkeepingOperatorService) {
  'ngInject';

  const vm = this;
  const orgId = $stateParams.orgId;

  vm.clients = [];
  vm.runs = [];
  vm.mappingItems = [];
  vm.artifacts = [];
  vm.selectedClient = $stateParams.client || null;
  vm.period = $stateParams.period || null;
  vm.loading = false;
  vm.engineUnavailable = false;
  vm.engineError = null;
  vm.writeResult = null;

  function handleError(message) {
    return function (error) {
      vm.loading = false;
      vm.engineUnavailable = error.status === 503;
      vm.engineError = error.data && error.data.error ? error.data.error : message;
      toaster.pop('error', 'Bookkeeping', vm.engineError);
    };
  }

  vm.loadClients = function () {
    vm.loading = true;
    BookkeepingOperatorService.clients(orgId).then(function (response) {
      vm.clients = response.data.clients || response.data || [];
      if (!vm.selectedClient && vm.clients.length > 0) {
        vm.selectedClient = vm.clients[0].slug || vm.clients[0].client || vm.clients[0].id;
      }
      vm.loading = false;
      if (vm.selectedClient) vm.refresh();
    }).catch(handleError('Failed to load bookkeeping clients'));
  };

  vm.refresh = function () {
    if (!vm.selectedClient) return;
    vm.loadRuns();
    vm.loadMappingReview();
    vm.loadArtifacts();
  };

  vm.loadRuns = function () {
    BookkeepingOperatorService.runs(orgId, { client: vm.selectedClient }).then(function (response) {
      vm.runs = response.data.runs || [];
      if (!vm.period && vm.runs.length > 0) {
        vm.period = vm.runs[0].period || vm.runs[0].through_month;
      }
    }).catch(handleError('Failed to load bookkeeping runs'));
  };

  vm.loadMappingReview = function () {
    BookkeepingOperatorService.mappingReview(orgId, { client: vm.selectedClient, period: vm.period }).then(function (response) {
      vm.mappingItems = response.data.items || response.data.mapping_review || [];
    }).catch(handleError('Failed to load mapping review'));
  };

  vm.loadArtifacts = function () {
    BookkeepingOperatorService.artifacts(orgId, { client: vm.selectedClient }).then(function (response) {
      vm.artifacts = response.data.artifacts || [];
    }).catch(handleError('Failed to load artifacts'));
  };

  vm.saveMappingDecisions = function () {
    BookkeepingOperatorService.saveMappingDecisions(orgId, {
      client: vm.selectedClient,
      period: vm.period,
      decisions: vm.mappingItems
    }).then(function (response) {
      vm.writeResult = response.data;
      toaster.pop('success', 'Bookkeeping', 'Mapping decisions saved');
      vm.refresh();
    }).catch(handleError('Failed to save mapping decisions'));
  };

  vm.generateReport = function () {
    BookkeepingOperatorService.generateReport(orgId, {
      client: vm.selectedClient,
      period: vm.period
    }).then(function (response) {
      vm.writeResult = response.data;
      toaster.pop('success', 'Bookkeeping', 'Report generation requested');
      vm.refresh();
    }).catch(handleError('Failed to generate report'));
  };

  vm.openArtifact = function (artifact) {
    const url = artifact.url || artifact.googleSheetUrl || artifact.href;
    if (url) window.open(url, '_blank');
  };

  vm.loadClients();
}

BookkeepingOperatorCtrl.$inject = ['toaster', '$stateParams', 'BookkeepingOperatorService'];

export default {
  name: 'BookkeepingOperatorCtrl',
  fn: BookkeepingOperatorCtrl
};
